module.exports = __webpack_public_path__ + "static/media/fp-post.54fd6119.jpeg";